import React from "react";
import { VMProvider } from "../../../commons/base/providers/provider";
import SOAdjustmentViewModel from "./view_models/so_adjustment_view_model";
import Scaffold from "../../../commons/scaffold/scaffold";
import SOAdjustmentFilterWidget from "./widgets/so_adjustment_filter_widget";
import SOAdjustmentTableWidget from "./widgets/so_adjustment_table_widget";
import SOAdjustmentModalWidget from "./widgets/so_adjustment_modal_widget";

export default class SOAdjustmentScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider create={() => new SOAdjustmentViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isLoading}
                        loadingBackgroundType="semi_transparent"
                        showSnackbar={vm.snackBar}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Adjust Form SO
                            </h1>
                            <SOAdjustmentFilterWidget />
                            {vm.isShowingModal && <SOAdjustmentModalWidget />}
                            <SOAdjustmentTableWidget />
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
